"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogHelper = void 0;
var TileType_1 = require("./TileType");
var DrawCards_1 = require("./deferredActions/DrawCards");
var SpaceBonus_1 = require("./SpaceBonus");
var LogHelper = (function () {
    function LogHelper() {
    }
    LogHelper.logAddResource = function (player, card, qty) {
        if (qty === void 0) { qty = 1; }
        var resourceType = 'resource(s)';
        if (card.resourceType) {
            resourceType = card.resourceType.toLowerCase() + '(s)';
        }
        player.game.log('${0} added ${1} ${2} to ${3}', function (b) {
            return b.player(player).number(qty).string(resourceType).card(card);
        });
    };
    LogHelper.logRemoveResource = function (player, card, qty, effect) {
        if (qty === void 0) { qty = 1; }
        var resourceType = 'resource(s)';
        if (card.resourceType) {
            resourceType = card.resourceType.toLowerCase() + '(s)';
        }
        player.game.log('${0} removed ${1} ${2} from ${3} to ${4}', function (b) {
            return b.player(player).number(qty).string(resourceType).card(card).string(effect);
        });
    };
    LogHelper.logTilePlacement = function (player, space, tileType) {
        this.logBoardTileAction(player, space, TileType_1.TileType.toString(tileType) + ' tile');
    };
    LogHelper.logBoardTileAction = function (player, space, description, action) {
        if (action === void 0) { action = 'placed'; }
        if (space.x === -1 && space.y === -1)
            return;
        if (player.name === 'neutral')
            return;
        var offset = Math.abs(space.y - 4);
        var row = space.y + 1;
        var position = space.x - offset + 1;
        player.game.log('${0} ${1} ${2} on row ${3} position ${4}', function (b) {
            return b.player(player).string(action).string(description).number(row).number(position);
        });
    };
    LogHelper.logColonyTrackIncrease = function (player, colony, steps) {
        if (steps === void 0) { steps = 1; }
        player.game.log('${0} increased ${1} colony track ${2} step(s)', function (b) {
            return b.player(player).colony(colony).number(steps);
        });
    };
    LogHelper.logTRIncrease = function (player, steps) {
        player.game.log('${0} gained ${1} TR', function (b) { return b.player(player).number(steps); });
    };
    LogHelper.logGlobalEventTRDecrease = function (player, steps) {
        if (steps === void 0) { steps = 1; }
        player.game.log('${0}\'s TR decreased ${1} step(s) due to global event', function (b) { return b.player(player).number(steps); });
    };
    LogHelper.logTemperatureIncrease = function (player, steps) {
        player.game.log('${0} increased temperature ${1} step(s)', function (b) { return b.player(player).number(steps); });
    };
    LogHelper.logVenusIncrease = function (player, steps) {
        player.game.log('${0} increased Venus scale ${1} step(s)', function (b) { return b.player(player).number(steps); });
    };
    LogHelper.logTargetedTurmoilDecrease = function (player, param) {
        switch (param) {
            case 'Ocean':
                player.game.log('${0} removed an ocean', function (b) { return b.player(player); });
                break;
            case 'Oxygen':
                player.game.log('${0} decreased oxygen level', function (b) { return b.player(player); });
                break;
            case 'Temperature':
                player.game.log('${0} decreased temperature', function (b) { return b.player(player); });
                break;
            case 'Venus':
                player.game.log('${0} decreased Venus scale', function (b) { return b.player(player); });
                break;
        }
    };
    LogHelper.logDiscardedCards = function (game, cards) {
        game.log('${0} card(s) were discarded', function (b) {
            b.rawString(cards.length.toString());
            for (var _i = 0, cards_1 = cards; _i < cards_1.length; _i++) {
                var card = cards_1[_i];
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
        });
    };
    LogHelper.logDrawnCards = function (player, cards, privateMessage, logType) {
        if (privateMessage === void 0) { privateMessage = false; }
        if (logType === void 0) { logType = DrawCards_1.LogType.DREW; }
        var message = '${0} ' + logType + ' ';
        var i = 0;
        if (cards.length === 0) {
            message += 'no cards';
        }
        else {
            for (var length_1 = cards.length; i < length_1; i++) {
                if (i > 0) {
                    if (i < length_1 - 1) {
                        message += ', ';
                    }
                    else {
                        message += ' and ';
                    }
                }
                message += '${' + (i + 1) + '}';
            }
        }
        var options = privateMessage ? { reservedFor: player } : {};
        player.game.log(message, function (b) {
            b.player(player);
            for (var _i = 0, cards_2 = cards; _i < cards_2.length; _i++) {
                var card = cards_2[_i];
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
        }, options);
    };
    LogHelper.logDraftedCards = function (player, draftedCards, passedCards, target) {
        var message = '${0} drafted';
        var i = 0;
        var offset = 1;
        if (draftedCards.length === 0) {
            message += ' no cards';
        }
        else {
            for (var length_2 = draftedCards.length; i < length_2; i++) {
                message += ' ${' + (i + offset) + '}';
            }
        }
        message += ' passing ';
        i = 0;
        offset += draftedCards.length;
        if (passedCards.length === 0) {
            message += 'no cards';
        }
        else {
            for (var length_3 = passedCards.length; i < length_3; i++) {
                if (i > 0) {
                    if (i < length_3 - 1) {
                        message += ', ';
                    }
                    else {
                        message += ' and ';
                    }
                }
                message += '${' + (i + offset) + '}';
            }
        }
        if (target !== undefined) {
            message += ' to ${' + (i + offset) + '}';
        }
        player.game.log(message, function (b) {
            b.player(player);
            for (var _i = 0, draftedCards_1 = draftedCards; _i < draftedCards_1.length; _i++) {
                var card = draftedCards_1[_i];
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
            for (var _a = 0, passedCards_1 = passedCards; _a < passedCards_1.length; _a++) {
                var card = passedCards_1[_a];
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
            b.string(target);
        }, { reservedFor: player });
    };
    LogHelper.logPlayerOrder = function (game, players) {
        var message = 'Player order: ';
        for (var i = 0; i < players.length; i++) {
            if (i > 0) {
                message += ', ';
            }
            message += players[i].name;
        }
        game.log(message);
    };
    LogHelper.logMsAs = function (game) {
        var messageMs = 'Milestones: ';
        for (var i = 0; i < game.milestones.length; i++) {
            if (i > 0) {
                messageMs += ', ';
            }
            messageMs += game.milestones[i].name;
        }
        var messageAs = 'Awards: ';
        for (var i = 0; i < game.awards.length; i++) {
            if (i > 0) {
                messageAs += ', ';
            }
            messageAs += game.awards[i].name;
        }
        game.log(messageMs);
        game.log(messageAs);
    };
    LogHelper.logColonies = function (game) {
        var message = 'Colonies: ';
        for (var i = 0; i < game.colonies.length; i++) {
            if (i > 0) {
                message += ', ';
            }
            message += game.colonies[i].name;
        }
        game.log(message);
    };
    LogHelper.logKnownEvents = function (game, FutureEventsShown) {
        var _a, _b, _c, _d, _e;
        game.log('EventQueue: ');
        game.log('Cu: ' + LogHelper.createEventMessage((_a = game.turmoil) === null || _a === void 0 ? void 0 : _a.currentGlobalEvent));
        game.log('Co: ' + LogHelper.createEventMessage((_b = game.turmoil) === null || _b === void 0 ? void 0 : _b.comingGlobalEvent));
        game.log('D: ' + LogHelper.createEventMessage((_c = game.turmoil) === null || _c === void 0 ? void 0 : _c.distantGlobalEvent));
        for (var j = 1; j <= FutureEventsShown; j++) {
            var event_1 = (_d = game.turmoil) === null || _d === void 0 ? void 0 : _d.globalEventDealer.globalEventsDeck[((_e = game.turmoil) === null || _e === void 0 ? void 0 : _e.globalEventDealer.globalEventsDeck.length) - j];
            game.log('D+' + j + ': ' + LogHelper.createEventMessage(event_1));
        }
    };
    LogHelper.logBoard = function (game) {
        game.log('Board');
        for (var i = 0; i < game.board.spaces.length; i++) {
            if (game.board.spaces[i].spaceType === 'colony')
                continue;
            if (game.board.spaces[i].bonus.length > 0) {
                game.log("Id: " + game.board.spaces[i].id + ", Type: " + game.board.spaces[i].spaceType + ", Bonus: " + game.board.spaces[i].bonus.map(function (key) { return SpaceBonus_1.SpaceBonus[key]; }).toString());
            }
            else {
                game.log("Id: " + game.board.spaces[i].id + ", Type: " + game.board.spaces[i].spaceType);
            }
        }
    };
    LogHelper.logFinalScore = function (game, player) {
        var vpb = player.getVictoryPoints();
        game.log("Player: " + player.name + ",                         TR: " + vpb.terraformRating + ",                         MS: " + vpb.milestones + ",                         AW: " + vpb.awards + ",                         Greenery: " + vpb.greenery + ",                         City: " + vpb.city + ",                         VP: " + vpb.victoryPoints + ",                         EV: " + vpb.escapeVelocity + ",                         Total: " + vpb.total + ",                         MC: " + player.megaCredits + ",                         Time: " + player.timer.getElapsedTimeInMinute() + ",                         Actions: " + player.actionsTakenThisGame);
    };
    LogHelper.createEventMessage = function (event) {
        if (typeof (event) !== 'undefined' && event !== null) {
            var message = event.name + ', Desc: ' + event.description;
            message += ', ' + event.revealedDelegate;
            message += ' / ' + event.currentDelegate;
            return message;
        }
        else {
            return 'None';
        }
    };
    return LogHelper;
}());
exports.LogHelper = LogHelper;
//# sourceMappingURL=LogHelper.js.map